import React from 'react';
import { withFormik, Form } from 'formik';
import styled from 'styled-components';
import { arrayMoveMutable } from 'array-move';
import * as yup from 'yup';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { addProgramSet } from '../../../modules/Program';
import ChooseClassModal from '../../../components/molecule/Modals/ChooseClassModal';
import Button from '../../../components/atomic/Buttons/Button';
import ProgramSets from './ProgramSets';
import { setGlobalLoadingSpinner } from '../../../modules/GlobalUI';
import { startPolling } from '../../../modules/UploadQueue';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 65%;
`
const FormStyled = styled(Form)`
  display: flex;
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

class ProgramsCreateForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      addWorkoutModalOpen: false,
      addWorkoutSetIndex: null,
      submitted: false,
    }
  }

  // componentWillUnmount() {
  //   this.props.submitForm();
  // }

  changeTracker = (value, name) => this.props.setFieldValue(name, value, true);

  openAddWorkoutModal = (addWorkoutSetIndex) => {
    this.setState({
      addWorkoutModalOpen: true,
      addWorkoutSetIndex,
    });
  }

  closeAddWorkoutModal = () => {
    this.setState({
      addWorkoutModalOpen: false,
    });
  }

  addWorkout = (item) => {
    const { values } = this.props;
    const { addWorkoutSetIndex } = this.state;

    const sets = [...values.sets];

    sets[addWorkoutSetIndex].classes.push(item);
    this.setState({ addWorkoutSetIndex: null });
    this.changeTracker(sets, 'sets');
  }

  onSortEnd = ({oldIndex, newIndex}, setIndex) => {
    const { values } = this.props;
    const sets = [...values.sets];

    arrayMoveMutable(sets[setIndex].classes, oldIndex, newIndex);

    this.changeTracker(sets, 'sets');
  }

  onRemove = (setIndex, index) => {
    const { values } = this.props;
    const sets = [...values.sets];
    sets[setIndex].classes.splice(index, 1);
    this.changeTracker(sets, 'sets');
  }

  addSet = async () => {
    const { addProgramSet, values } = this.props;
    const newSet = await addProgramSet(values.id);
    const sets = [...values.sets];
    sets.push(newSet);
    this.changeTracker(sets, 'sets');
  }

  render () {

    const {
      authState: { userData },
      values,
      startPolling,
      uploadQueueState: { programOverviewVideos },
      setFieldValue,
      programFormState,
      submitForm
    } = this.props;

    const { addWorkoutModalOpen } = this.state;

    return (
      <FormStyled>
        <Container>
          <ProgramSets
            addWorkout={this.openAddWorkoutModal}
            sets={values.sets}
            onRemove={this.onRemove}
            onSortEnd={this.onSortEnd}
            userData={userData}
            startPolling={startPolling}
            values={values}
            setFieldValue={setFieldValue}
            programOverviewVideos={programOverviewVideos}
            programFormState={programFormState}
            submitForm={submitForm}
          />
          <ButtonWrapper>
            <Button color="primary" variant="contained" onClick={this.addSet}>
              Add Week
            </Button>
          </ButtonWrapper>
          <ChooseClassModal
            anchor='right'
            open={addWorkoutModalOpen}
            onBackdropClick={this.closeAddWorkoutModal}
            onClose={this.closeAddWorkoutModal}
            onSubmit={this.addWorkout}
            cardButtonIcon='add'
          />
        </Container>
      </FormStyled>
    );
  }
};

function mapStateToProps(state) {
  return {
    authState: state.authState,
    programFormState: state.programFormState,
    uploadQueueState: state.uploadQueueState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addProgramSet: addProgramSet,
    setGlobalLoadingSpinner: setGlobalLoadingSpinner,
    startPolling: startPolling,
  }, dispatch)
}

export default compose(connect(mapStateToProps,mapDispatchToProps), withFormik({
  mapPropsToValues: props => Object.assign(props.initialValues),

  validationSchema: yup.object().shape({
    name: yup.string(),
  }),

  validate: (values, props) => {
    props.submit(values);
  },

  handleSubmit: (values, { props, setSubmitting }) => {
    props.submit(values);
    setSubmitting(false);
  },

  displayName: 'ProgramsCreateForm',
}))(ProgramsCreateForm);
